import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { when } from 'mobx';
import React from 'react';
import { createRoot } from 'react-dom/client';

export class CartWidgetSdk {
  private static readonly CLASSNAME = 'coretava-cart-widget';

  private static readonly RENDERED_DATA_ATTRIBUTE = 'data-rendered';

  private static readonly IS_MINI_CART_DATA_ATTRIBUTE = 'data-is-mini-cart';

  private static readonly URL_SELECTOR_CART_DATA_ATTRIBUTE = 'data-url-selector';

  constructor() {
    when(() => (AppStore.initialized), () => {
      if (AppStore.app.enabled) {
        this.renderWidget();
      }
    });
  }

  private renderWidget(): void {
    const observer = new MutationObserver(() => {
      const elements = document.querySelectorAll(`.${CartWidgetSdk.CLASSNAME}:not([${CartWidgetSdk.RENDERED_DATA_ATTRIBUTE}="true"])`);
      if (elements.length > 0) {
        Array.from(elements)
          .forEach((element) => {
            element.setAttribute(CartWidgetSdk.RENDERED_DATA_ATTRIBUTE, 'true');
            const Component = React.lazy(() => import('apps/loyalty-station/desktop/src/frames/widgets/cart'));

            createRoot(element)
              .render(
                <React.Suspense fallback={<div />}>
                  <Component
                    isMiniCart={element.getAttribute(CartWidgetSdk.IS_MINI_CART_DATA_ATTRIBUTE) === 'true'}
                    urlSelector={element.getAttribute(CartWidgetSdk.URL_SELECTOR_CART_DATA_ATTRIBUTE) ?? undefined}
                  />
                </React.Suspense>,
              );
          });
      }
    });

    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }
}
